import * as type from "./type";

const initialState = {
  getUserLogs: null,
  deleteUserLog: null,
};

const AdminUserLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_USER_LOG_LIST_REQUEST:
      return { ...state, getUserLogs: null };
    case type.GET_USER_LOG_LIST_SUCCESS:
      return { ...state, getUserLogs: action.payload };
    case type.DELETE_USER_LOG_REQUEST:
      return { ...state, deleteUserLog: null };
    case type.DELETE_USER_LOG_SUCCESS:
      return { ...state, deleteUserLog: action.payload };
    case type.CLEAR_USER_LOG_LIST:
      return { ...state, getUserLogs: null, deleteUserLog: null };
    default:
      return {
        ...state,
      };
  }
};
export default AdminUserLogReducer;
